import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { MijnOmgevingNavigation } from '../../mijn-omgeving.navigation';

import { BusinessCustomerService } from './business-customer.service';

@Injectable({ providedIn: 'root' })
export class BusinessCustomerGuard {
    public constructor(
        private readonly businessCustomerService: BusinessCustomerService,
        private readonly mijnOmgevingNavigation: MijnOmgevingNavigation
    ) {}

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.businessCustomerService.isBusinessCustomer().pipe(
            switchMap((isBusinessCustomer) => {
                if (isBusinessCustomer) {
                    if (
                        (route.data.allowBusiness && this.businessCustomerService.isBusiness()) ||
                        (route.data.allowSelfEmployed && this.businessCustomerService.isSelfEmployed())
                    ) {
                        return of(true);
                    }
                    this.navigateOnError(route.data.contextErrorPath);
                }
                return of(!isBusinessCustomer);
            }),
            catchError(() => of(true))
        );
    }

    private navigateOnError(contextErrorPath: string): void {
        if (contextErrorPath) {
            this.mijnOmgevingNavigation.internal(contextErrorPath);
        } else {
            this.mijnOmgevingNavigation.toHomepage();
        }
    }
}
